// src/agreements.ts
var AgreementProvider = /* @__PURE__ */ ((AgreementProvider2) => {
  AgreementProvider2["DROPBOX_SIGN"] = "DROPBOX_SIGN";
  AgreementProvider2["DOCUSEAL"] = "DOCUSEAL";
  return AgreementProvider2;
})(AgreementProvider || {});
var SIGNER_1 = "signer1";
var SIGNER_2 = "signer2";
var SIGNER_3 = "signer3";
var SIGNER_4 = "signer4";
var SIGNER_5 = "signer5";
var COUNTERSIGNER = "countersigner";
var SIGNER_X = (x) => `signer${x}`;
var AWAITING_SIGNATURE = "awaiting_signature";
var SIGNED = "signed";
var SIGNING_PARTY_ORDER = {
  orderBy: { order: { sort: "asc", nulls: "last" } }
};
var SIGNATURES_PENDING_DESCRIPTION = "Your investment will not be completed until all required parties have signed the subscription agreement.";
var SIGNER_ROLES = {
  SIGNER_1,
  SIGNER_2,
  SIGNER_3,
  SIGNER_4,
  SIGNER_5,
  COUNTERSIGNER
};
var SigningPartyStatus = /* @__PURE__ */ ((SigningPartyStatus2) => {
  SigningPartyStatus2["SIGNED"] = "signed";
  SigningPartyStatus2["AWAITING"] = "awaiting_signature";
  SigningPartyStatus2["SENT"] = "sent";
  SigningPartyStatus2["OPENED"] = "opened";
  SigningPartyStatus2["DECLINED"] = "declined";
  return SigningPartyStatus2;
})(SigningPartyStatus || {});
var SIGNING_PARTY_STATUS_CONFIG_MAP = {
  ["signed" /* SIGNED */]: {
    color: "green",
    bg: "green.50",
    border: "green.200",
    textColor: "green.600",
    display: "SIGNED"
  },
  ["awaiting_signature" /* AWAITING */]: {
    color: "gray",
    bg: "gray.50",
    border: "gray.200",
    textColor: "gray.600",
    display: "AWAITING"
  },
  ["sent" /* SENT */]: {
    color: "gray",
    bg: "gray.50",
    border: "gray.200",
    textColor: "gray.600",
    display: "SENT"
  },
  ["opened" /* OPENED */]: {
    color: "orange",
    bg: "orange.50",
    border: "orange.200",
    textColor: "orange.600",
    display: "OPENED"
  },
  ["declined" /* DECLINED */]: {
    color: "red",
    bg: "red.50",
    border: "red.200",
    textColor: "red.600",
    display: "DECLINED"
  }
};
var InvestmentAgreementStatus = /* @__PURE__ */ ((InvestmentAgreementStatus2) => {
  InvestmentAgreementStatus2["PENDING"] = "PENDING";
  InvestmentAgreementStatus2["SIGNED"] = "SIGNED";
  InvestmentAgreementStatus2["COMPLETED"] = "COMPLETED";
  InvestmentAgreementStatus2["VOIDED"] = "VOIDED";
  InvestmentAgreementStatus2["CANCELED"] = "CANCELED";
  return InvestmentAgreementStatus2;
})(InvestmentAgreementStatus || {});
var OfferingAgreementStatus = /* @__PURE__ */ ((OfferingAgreementStatus2) => {
  OfferingAgreementStatus2["DRAFT"] = "DRAFT";
  OfferingAgreementStatus2["LIVE"] = "LIVE";
  return OfferingAgreementStatus2;
})(OfferingAgreementStatus || {});
var AgreementHistoryAction = /* @__PURE__ */ ((AgreementHistoryAction2) => {
  AgreementHistoryAction2["CREATED"] = "CREATED";
  AgreementHistoryAction2["EDITED"] = "EDITED";
  AgreementHistoryAction2["PUBLISHED"] = "PUBLISHED";
  return AgreementHistoryAction2;
})(AgreementHistoryAction || {});
export {
  AWAITING_SIGNATURE,
  AgreementHistoryAction,
  AgreementProvider,
  COUNTERSIGNER,
  InvestmentAgreementStatus,
  OfferingAgreementStatus,
  SIGNATURES_PENDING_DESCRIPTION,
  SIGNED,
  SIGNER_1,
  SIGNER_2,
  SIGNER_3,
  SIGNER_4,
  SIGNER_5,
  SIGNER_ROLES,
  SIGNER_X,
  SIGNING_PARTY_ORDER,
  SIGNING_PARTY_STATUS_CONFIG_MAP,
  SigningPartyStatus
};
//# sourceMappingURL=agreements.mjs.map